// Utility for generating and managing daily passcodes
import { format, isAfter, parse, addDays } from 'date-fns';

// Generate a deterministic passcode for a specific date
const generatePasscodeForDate = (date) => {
  // Format date as YYYYMMDD to use as seed
  const dateStr = format(date, 'yyyyMMdd');
  
  // Simple hash function to generate a 4-digit number from the date string
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    hash = ((hash << 5) - hash) + dateStr.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Make positive and take last 4 digits
  hash = Math.abs(hash) % 10000;
  
  // Ensure it's 4 digits by padding with leading zeros
  return hash.toString().padStart(4, '0');
};

// Get the current valid passcode
const getCurrentPasscode = (resetHour = 7, resetMinute = 0) => {
  const now = new Date();
  const today = new Date(now);
  
  // Get reset time from parameters or use default (7:00 AM)
  const resetTime = new Date(today.setHours(resetHour, resetMinute, 0, 0));
  
  // If current time is before reset time, use yesterday's passcode
  if (now < resetTime) {
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    return generatePasscodeForDate(yesterday);
  } else {
    // Otherwise use today's passcode
    return generatePasscodeForDate(now);
  }
};

// Get passcodes for a range of days
const getPasscodesForRange = (startDate, days = 30, resetHour = 7, resetMinute = 0) => {
  const passcodes = [];
  let currentDate = new Date(startDate);
  
  for (let i = 0; i < days; i++) {
    passcodes.push({
      date: format(currentDate, 'yyyy-MM-dd'),
      passcode: generatePasscodeForDate(currentDate),
      displayDate: format(currentDate, 'dd MMM yyyy'),
      resetTime: `${resetHour}:${resetMinute.toString().padStart(2, '0')} AM`
    });
    currentDate = addDays(currentDate, 1);
  }
  
  return passcodes;
};

export { getCurrentPasscode, generatePasscodeForDate, getPasscodesForRange };